import { SHIFT_ITEM_TYPE } from '../../../shared/utils/constants';

const validate = (values) => {
  const between = (value, minValue, maxValue) => {
    const min = parseInt(minValue.replace(':', ''), 10);
    const max = parseInt(maxValue.replace(':', ''), 10);
    const valueFormatted = value ? parseInt(value.replace(':', ''), 10) : -1;
    return valueFormatted >= min && valueFormatted <= max;
  };

  const finalTime = `"${values.finalTime}"`.replace(/[^\d]+/g, '');
  const consolidationDiaryHour = `"${values.consolidationTime}"`.replace(
    /[^\d]+/g,
    ''
  );
  const errors = {};
  if (!values.name) {
    errors.name = 'Esse campo não pode ficar vazio';
  }

  if (!values.startTime) {
    errors.startTime = 'Esse campo não pode ficar vazio';
  }

  if (!values.finalTime) {
    errors.finalTime = 'Esse campo não pode ficar vazio';
  }

  if (!values.consolidationTime) {
    errors.consolidationTime = 'Esse campo não pode ficar vazio';
  } else if (consolidationDiaryHour - finalTime < 30) {
    errors.consolidationTime =
      'A consolidação deve ser de pelo menos 30 minutos após o fim';
  }

  if (!values.classQuantity) {
    errors.classQuantity = 'Esse campo não pode ficar vazio';
  } else if (Number(values.classQuantity <= 0)) {
    errors.classQuantity = 'Digite uma quantidade de aulas válida';
  }
  if (values.finalTime <= values.startTime) {
    errors.finalTime = 'A aula precisa terminar após o início dela';
  }
  if (!values.intervalQuantity) {
    errors.intervalQuantity = 'Esse campo não pode ficar vazio';
  }

  if (Number(values.intervalQuantity) < 0) {
    errors.intervalQuantity = 'Digite uma quantidade de intervalos válido';
  }
  if (values.items && values.items.length > 0) {
    const { items } = values;
    if (
      !items.every(
        (item) =>
          item.startAt && item.startAt.length && item.endAt && item.endAt.length
      )
    ) {
      errors.errorIntervalTime = 'Informe os horários';
    }
    if (items.every((item) => item.startAt || item.endAt)) {
      items.forEach((item) => {
        if (!between(item.startAt, values.startTime, values.finalTime)) {
          errors.errorIntervalTime = `Informe um horário de início válido no campo ${
            item.type === SHIFT_ITEM_TYPE.CLASS
              ? `${item.sequence}º Aula`
              : 'Intervalo'
          }`;
        }
        if (!between(item.endAt, values.startTime, values.finalTime)) {
          errors.errorIntervalTime = `Informe um horário de início válido no campo ${
            item.type === SHIFT_ITEM_TYPE.CLASS
              ? `${item.sequence}º Aula`
              : 'Intervalo'
          }`;
        }
      });
    }
  }

  return errors;
};

export default validate;
